import { useRouteError } from "react-router-dom";

export default function NotFoundPage() {
  return (
    <div>
      <h3>Oops!!.. Resource not found!</h3>
      <p>
        Seems like the resource you're looking for does not exist or has moved
      </p>
    </div>
  );
}

export function ErrorPage() {
  return (
    <div>
      <h2>Oops!!.. An error occured!</h2>
      <p>We will update this as quickly as possible</p>
    </div>
  );
}
